import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles: ComponentStylesProps<boolean> = {
  // Used from CartPage component
  header: {
    margin: { top: '5.6rem', bottom: '5.2rem', left: 'auto', right: 'auto' },
    maxWidth: '109.6rem',
    '& p': {
      maxWidth: '50rem',
    },
  },
  section: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '3.4rem 4rem',
    [breakpoints.sm.down]: {
      padding: '1.4rem 2rem 4rem',
    },
  },
  actionButton: () => ({
    textTransform: 'uppercase',
    [breakpoints.md.down]: {
      paddingLeft: 0,
    },
    '&:disabled': {
      color: colors.neutral[600],
      backgroundColor: 'transparent',
    },
  }),
  productLineTitle: {
    paddingBottom: '2.8rem',
    marginBottom: '4rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    '& span': {
      fontSize: '2.4rem',
      lineHeight: '3.2rem',
    },
    [breakpoints.sm.down]: {
      marginBottom: '2.8rem',
      paddingBottom: '1.8rem',
    },
  },
  productLineSectionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3.2rem',
  },
  cardsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
  },
  benefitsList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2.4rem',
    [breakpoints.sm.down]: {
      gap: '1.8rem',
    },
  },
  crossSellModalProductLinesList: {
    justifyContent: 'center',
    margin: '5rem auto',
  },
  benefitsTitle: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem',
    marginBottom: '2.8rem',
    marginTop: '1rem',
    [breakpoints.sm.down]: {
      fontSize: '1.8rem',
    },
  },
  benefitsSection: (isCartEmpty) => ({
    marginTop: !isCartEmpty && '3.2rem',
  }),
  innerContent: {
    minHeight: '60vh',
    position: 'relative',
  },
  actionButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '4rem',
    marginTop: '8rem',
    '& button': {
      minWidth: '32rem',
    },
    '@media(max-width: 540px)': {
      marginTop: '6rem',
      '& button': {
        minWidth: '28rem',
      },
    },
  },
  contactButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  buttonDescription: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: colors.neutral[900],
    textAlign: 'center',
    maxWidth: '30rem',
  },
  cartItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '3rem',
    [breakpoints.lg.down]: {
      flexDirection: 'column-reverse',
      '&:not(:last-child)': {
        paddingBottom: '4rem',
        borderBottom: `0.1rem solid ${colors.neutral[300]}`,
      },
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
